import Reveal from "@/components/site/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Program & Rig-Up",
    body: "We review the well program, mobilize the unit and rig up pressure control at the wellhead. Every connection is pressure-tested before we go in hole.",
  },
  {
    n: "02",
    title: "Run In Hole",
    body: "Armored cable conveys the tool string to depth under controlled tension. Surface panels monitor line speed, tension and telemetry in real time.",
  },
  {
    n: "03",
    title: "Acquire & Correlate",
    body: "Downhole instruments log the target interval. Depth is correlated to reference logs so every reading ties to a known point in the well.",
  },
  {
    n: "04",
    title: "Deliver & Rig-Down",
    body: "Quality-checked data is delivered to the company representative on site. We rig down clean and leave the location the way we found it.",
  },
];

export default function Record() {
  return (
    <section
      id="record"
      className="relative bg-secondary/30 border-b border-white/10 py-24 md:py-40"
      data-testid="record-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal className="max-w-3xl mb-16 md:mb-24">
          <span className="mono-label text-primary">/ Field method</span>
          <h2 className="mt-6 font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-[0.9]">
            How a job
            <br />
            actually runs
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, i) => (
            <Reveal
              key={s.n}
              delay={i * 0.06}
              className="bg-background p-8 md:p-12 group"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-mono-tech text-4xl md:text-5xl text-primary">
                  {s.n}
                </span>
                <div>
                  <h3 className="font-display font-bold uppercase tracking-tight text-2xl md:text-3xl mb-4">
                    {s.title}
                  </h3>
                  <p className="text-foreground/60 leading-relaxed max-w-md">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
